import axios from 'axios';
import { User } from './userApi';

export interface Branch {
  id: string;
  name: string;
  country: string;
  state: string;
  createdOn?: string;
  createdByUser?: User;
  createdByUserId?: string;
  updatedOn?: string;
  updatedByUser?: User;
  updatedByUserId?: string;
}

export async function getBranches() {
  const res = await axios.get('/api/v1/branch');
  return res.data as Branch[];
}

export async function createBranch({
  name,
  country,
  state,
}: {
  name: string;
  country: string;
  state: string;
}) {
  const res = await axios.post('/api/v1/branch', {
    name,
    country,
    state,
  });
  return res.data;
}

export async function updateBranch({
  id,
  name,
  country,
  state,
}: {
  id: string;
  name: string;
  country: string;
  state: string;
}) {
  const res = await axios.put(`/api/v1/branch/${id}`, {
    name,
    country,
    state,
  });
  return res.data;
}

export async function deleteBranch(id: string) {
  const res = await axios.delete(`/api/v1/branch/${id}`);
  return res.data;
}
